import { FocusNode } from '@please/lrud'
import styled from 'styled-components'

import { IndicatorWrapper } from '@/components/DotIndicator/styles'
import { LineTileShape } from '@/constants/common'
import { classicTilesPerRow, squareTilesPerRow } from '@/constants/list'
import { ScrollContainer } from '@/containers/styles'

import { getTileProps } from '../Lines/utils'

export const ListElem = styled(FocusNode)`
  position: relative;
  display: flex;
  ${IndicatorWrapper} {
    height: 850px;
    right: 40px;
  }
  ${ScrollContainer} {
    padding-top: 24px;
    margin-top: -24px;
  }
`
export const ListRow = styled(FocusNode)<{
  $tileShape: LineTileShape
}>`
  position: relative;
  display: flex;
  flex-direction: row;
  margin-bottom: 24px;
  & .slider__item {
    margin-right: ${({ $tileShape }) =>
      $tileShape === LineTileShape.ASPECT16x9 ? '24px' : '18px'};
  }
`

export const ListLoader = styled.div<{
  $tileShape: LineTileShape
}>`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${({ $tileShape }) => `${getTileProps($tileShape).h}px`};
  width: ${({ $tileShape }) =>
    $tileShape === LineTileShape.ASPECT16x9
      ? `${(getTileProps($tileShape).w + 24) * classicTilesPerRow}px`
      : `${(getTileProps($tileShape).w + 18) * squareTilesPerRow}px`};
`
export const ListTitle = styled.div`
  margin-bottom: 18px;
  font-weight: 600;
  font-size: 26px;
  line-height: 30px;
  text-transform: uppercase;
  color: ${(props) => props.theme.colors.sectionGrid.title};
  opacity: 0.9;
`
export const ScrollbarWrapper = styled.div`
  display: flex;
  align-items: center;
`
